import { ServiceOptionItem } from '../../../../ServiceSummary/types';
import { format } from '../../../../utils';
import type { DirectionSegment, DirectionSegmentGroup } from '../model/types';

export interface InsuranceDirection {
	key: string;
	dateLabel: string;
	items: ServiceOptionItem[];
}

const getDirectionDateLabel = (segments: DirectionSegment[] = []): string => {
	const departure = segments[0]?.departure;
	const arrival = segments[segments.length - 1]?.arrival;

	if (!departure?.date) {
		return null;
	}

	return `${format(departure.date, 'd MMM, EEEEEE')} • ${departure.time} — ${arrival?.time ?? ''}`;
};

export const splitByDirection = (
	items: ServiceOptionItem[],
	segmentGroups: DirectionSegmentGroup[]
): InsuranceDirection[] => {
	const passengersCount = new Set(items.map(item => item.passengerName)).size;
	const directionsCount = passengersCount ? items.length / passengersCount : 0;

	const isSplittable =
		Number.isInteger(directionsCount) && directionsCount > 1 && directionsCount <= segmentGroups.length;

	if (!isSplittable) {
		return [{ key: 'all', dateLabel: getDirectionDateLabel(segmentGroups[0]?.segments), items }];
	}

	return Array.from({ length: directionsCount }, (_, index) => ({
		key: segmentGroups[index].groupId,
		dateLabel: getDirectionDateLabel(segmentGroups[index].segments),
		items: items.slice(index * passengersCount, (index + 1) * passengersCount)
	}));
};
